<template>
	<div>
		<app-header />

		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<li class="breadcrumb-item active" aria-current="page">
						{{ _lang("Users") }}
					</li>
					<li class="breadcrumb-item active" aria-current="page">
						{{ _lang("Edit") }}
					</li>
				</ol>
			</nav>

			<form method="post" @submit.prevent="onSubmit">
				<div class="form-group">
					<label>{{ _lang("Name") }}</label>
					<input
						v-model="user.name"
						type="text"
						class="form-control"
						required
					/>
				</div>
				<div class="form-group">
					<label>{{ _lang("Email") }}</label>
					<input
						v-model="user.email"
						type="email"
						class="form-control"
						required
					/>
				</div>
				<div class="form-group">
					<label>{{ _lang("Password") }}</label>
					<input
						v-model="user.password"
						type="password"
						class="form-control"
						:required="!id"
					/>
					<small v-if="id">{{ _lang("Leave empty to keep the same password") }}</small>
				</div>


				<div class="form-group">
					<label>{{ _lang("Access level") }}</label>
					<select
						v-model="access_level"
						class="form-control"
						required
					>
						<option value="admin">{{ _lang("Admin") }}</option>
						<option value="all_projects">{{ _lang("All projects") }}</option>
						<option value="projects_whitelist">{{ _lang("Whitelist") }}</option>
						<option value="projects_blacklist">{{ _lang("Blacklist") }}</option>
					</select>

				</div>

				<div v-if="['projects_whitelist','projects_blacklist'].includes(access_level)" class="form-group">

					<label>{{ _lang('Projects') }}</label>
					<div class="project-list">
						<div v-for="project in projects" v-bind:key="project.id">
							<label><input type="checkbox" v-model="selected_projects" :value="project.id" /> {{ project.name }} ({{ project.domain || project.slug }})</label>
						</div>
					</div>


					<!-- number of project selected / select none / invert selection -->
					<span class="text-muted">{{ selected_projects.length }} {{ _lang('selected') }}</span> /
					<span class="hand text-primary" @click="selected_projects = []">{{ _lang('Select none') }}</span> /
					<span class="hand text-primary" @click="selected_projects = projects.map(p=>p.id).filter(id=>!selected_projects.includes(id))">{{ _lang('Invert selection') }}</span>

				</div>

				<button type="submit" class="btn btn-primary">
					{{ _lang("Save") }}
				</button>
				<span class="btn btn-light" @click="goBack">{{
					_lang("Back")
				}}</span>
			</form>
		</div>
	</div>
</template>
<style>
	.project-list {
		max-height:400px;
		overflow-y:auto;
	}
</style>

<script>
import componentFunctions from "../mixin.components.js";
import axios from "axios";
import appHeader from "../components/appHeader.vue";

export default {
	props: ["id"],
	mixins: [componentFunctions],
	components: {
		appHeader
	},
	data() {
		return {
			user: {
				name: "",
				email: "",
				password: "",
			},
			access_level: "all_projects",
			projects:[],
			selected_projects: [],
		};
	},
	methods: {
		goBack() {
			this.$router.go(-1);
			this.$router.push({
				name: "users",
			});
		},
		onSubmit() {

			let data = {
				name: this.user.name,
				email: this.user.email,
			};
			if(this.user.password){
				data.password = this.user.password;
			}
			if(this.access_level === 'admin'){
				data.is_business_admin = true;
			} else {
				data.is_business_admin = false;
			}

			const permissions = {};

			if(this.access_level === 'admin'){
				// do nothing, leave permissions empty
			} else if(this.access_level === 'all_projects'){
				permissions.all_projects = true;
			} else if(this.access_level === 'projects_whitelist'){
				permissions.projects_whitelist = this.selected_projects;
			} else if(this.access_level === 'projects_blacklist'){
				permissions.projects_blacklist = this.selected_projects;
			}

			data.permissions = permissions;


			axios({
				method: "post",
				url: `/api/business/users`.concat(this.id?'/'+this.id:''),
				data: data
			}).then(res => {
				toastr("User updated successfully", "Success", "#4BB543");
				this.$router.push('/users');
			}).catch(err => {
				toastr(err.message,'Error','#cc0000');
			});


		},

		getProjects(){
			this.$store.dispatch('startLoading');
			axios({
				url: '/api/projects',
			}).then((res) => {
				this.projects = res.data;
			}).finally(()=>{
				this.$store.dispatch('stopLoading');
			});
		},
		getUser(){
			this.$store.dispatch('startLoading');
			axios({
				method: "get",
				url: `/api/business/users/${this.id}`,
			}).then(res => {
				this.user.name = res.data.name;
				this.user.email = res.data.email;
				const permissions = res.data.permissions || {};
				if(res.data.is_business_admin){
					this.access_level = 'admin';
				} else if( 'all_projects' in permissions && permissions.all_projects){
					this.access_level = 'all_projects';
				} else if ('projects_whitelist' in permissions){
					this.access_level = 'projects_whitelist';
					this.selected_projects = 'projects_whitelist' in permissions ? permissions.projects_whitelist : [];
				} else if ('projects_blacklist' in permissions){
					this.access_level = 'projects_blacklist';
					this.selected_projects = 'projects_blacklist' in permissions ? permissions.projects_blacklist : [];
				}
			}).catch(err => {
				toastr(err.message,'Error','#cc0000');
				this.$router.push('/users');
			}).finally(()=>{
				this.$store.dispatch('stopLoading');
			});
		},

	},
	mounted() {
		if(this.id) this.getUser();
		this.getProjects();
	}
};
</script>
